export default {
	default: {
		width: 0.15,
		depth: 0.15,
	},
	toCorner: {
		width: 0.15,
		depth: 1.05,
	},
	deepChildOnly: {
		width: 4,
		depth: 1.2,
	},
	child: {
		width: 0.3,
		depth: 0.3,
	},
	separate: {
		width: 0.05,
		depth: 0.05,
	},
};
